import React, {useState} from "react";
import Btn100 from '../views/component/Btn100'
import Tab from '../views/component/Tab'
import Dropdown from '../views/component/Dropdown'
import Radio from '../views/component/Radio'
import TextRadio from '../views/component/TextRadio'
import TextInput from "./component/TextInput";
import Toggle from "./component/Toggle";
import FilterModal from "./component/FilterModal";
import SmallCardHorizontal from "./set/SmallCardHorizontal";
import LargeCardVertical from "./set/LargeCardVertical";
import SmallCardVertical from "./set/SmallCardVertical";
import BtnMedium from "./component/BtnMedium";
import BtnSm from "./component/BtnSm";
import BtnText from "./component/BtnText";
import Checkbox from "./component/Checkbox";
import Toast from './component/Toast'
import ConfirmModal from "./component/ConfirmModal";

function DesignSystem() {

  const componentList = [
      {
        eng: 'button',
        ko: '버튼',
      },
      {
        eng: 'textInput',
        ko: '텍스트 인풋',
      },
      {
        eng: 'radio',
        ko: '라디오',
      },
      {
        eng: 'checkbox',
        ko: '체크박스',
      },
      {
        eng: 'dropdown',
        ko: '드롭다운',
      },
      {
        eng: 'tap',
        ko: '탭',
      },
      {
        eng: 'toast',
        ko: '토스트',
      },
      {
        eng: 'confirmModal',
        ko: '컨펌모달',
      },
      {
        eng: 'toggle',
        ko: '토글',
      },
      {
        eng: 'filter',
        ko: '필터',
      }
    ]

  const setList = [
    {
      eng: 'smallCardHorizontal',
      ko: '작은카드-수평',
    },
    {
      eng: 'smallCardVertical',
      ko: '작은카드-수직',
    },
    {
      eng: 'largeCardVertical',
      ko: '큰카드-수직',
    },
  ]

  const filterList = [
    {
      ko: '힘들때 보면 도움되는 광고',
      data: 'filter01',
    },
    {
      ko: '따라해보고 싶은 광고',
      data: 'filter02',
    },
    {
      ko: '비가 오면 보고싶은 광고',
      data: 'filter03',
    },
    {
      ko: '일에 집중할 떄 보는 광고',
      data: 'filter04',
    },
    {
      ko: '2022년 가장 핫했던 광고',
      data: 'filter05',
    },
  ]

  //------------------------------------------------For Design System-------------------------------------------------//

  const [switchSection, setSwitchSection] = useState('set');
  const [selectedComponent, setSelectedComponent] = useState(componentList[0].eng);
  const [selectedSet, setSelectedSet] = useState(setList[0].eng);



  //--------------------------------------------------For Component---------------------------------------------------//

  const adList = ['TVCF','RADIO','PRINT','OOH','CINEMA'];
  const adListObject = [
    {kor: 'TVCF'},
    {kor: 'RADIO'},
    {kor: 'PRINT'},
    {kor: 'OOH'},
    {kor: 'CINEMA'},
  ];
  const radioList = ['최신순','인기순','조회순'];

  const [selectedRadio, setSelectedRadio] = useState(radioList[0]);                             // Radio
  const [selectedAd, setSelectedAd] = useState(adListObject[0].kor);                            // Dropdown
  const [confirmModal, setConfirmModal] = useState(false);                             // ConfirmModal
  const [filterModal, setFilterModal] = useState(false);                               // FilterModal

  //--------------------------------------------------For set---------------------------------------------------//

  const setData = [
    {
      index: 1,
      data: {
        thumbnail: 'https://ssl.pstatic.net/melona/libs/1421/1421100/a8ab267b1be3e523f8ee_20221109154654830.jpg',
        title: '파크솔레이유',
        brand: '포스코더샵',
        wdate: '20221110',
        rcount: '16'
      }
    },
    {
      index: 2,
      data: {
        thumbnail: 'https://ssl.pstatic.net/melona/libs/1421/1421100/a8ab267b1be3e523f8ee_20221109154654830.jpg',
        title: '파크솔레이유',
        brand: '포스코더샵',
        wdate: '20221110',
        rcount: '17'
      }
    },
  ]


  return (
    <div id="designSystem">
      <h2 id="designSystemHeading">DesignSystem</h2>
      <button className={`section-move-btn ${switchSection === 'component' ? "clicked" : ""}`} onClick={() => setSwitchSection('component')}>Component</button>
      <button className={`section-move-btn ${switchSection === 'set' ? "clicked" : ""}`} onClick={() => setSwitchSection('set')}>SET</button>
      {
        switchSection === 'component' &&
        <>
          <Tab
            additionalClassName="mt-4 mb-4"
            selectedThing={selectedComponent}
            setSelectedThing={setSelectedComponent}
            thingsList={componentList}
          />
          {
            selectedComponent === 'button' &&
            <>
              <Btn100 text="적용" additionalClass="mb-2"/>
              <Btn100 text="확인" radius={true} additionalClass="mb-2"/>
              <Btn100 text="적용" radius={true} disabled={true} additionalClass="mb-2"/>
              <Btn100 text="적용" radius={true} secondary={true} additionalClass="mb-2"/>
              <div className="d-flex gap-1 mb-2">
                <BtnMedium text="재생" icon="mdi mdi-play"/>
                <BtnMedium text="정지" icon="mdi mdi-stop"/>
              </div>
              <div className="d-flex gap-1 mb-2">
                <BtnSm text="취소" color="black"/>
                <BtnSm text="만들기" color="blue"/>
              </div>
              <div className="d-flex gap-1 mb-2">
                <BtnText text="광고물 제공신청" rightIcon="chevron-right" color="gray"/>
                <BtnText text="전체보기" rightIcon="chevron-right" color="gray"/>
                <BtnText text="전체보기" leftIcon="plus-box-outline" color="blue"/>
              </div>
            </>
          }
          {
            selectedComponent === 'textInput' &&
            <TextInput
              hasLabel={true}
              labelText="이메일"
              placeHolderText="이메일을 입력하세요"
              hasLeftIcon={true}
              leftIconName="magnify"
              hasErrorText={false}
              errorText="형식이 맞지 않습니다"
            />
          }
          {
            selectedComponent === 'radio' &&
            <>
              <Radio
                additionalClassName="mt-4 mb-4"
                selectedThing={selectedRadio}
                setSelectedThing={setSelectedRadio}
                thingsList={radioList}
              />
              <TextRadio
              additionalClassName="mt-4 mb-4"
              selectedThing={selectedRadio}
              setSelectedThing={setSelectedRadio}
              thingsList={radioList}
              />
            </>
          }
          {
            selectedComponent === 'checkbox' &&
            <Checkbox text="sampleText" checkboxName="one"/>
          }
          {
            selectedComponent === 'dropdown' &&
            <Dropdown
              additionalClassName="sample"
              selectedThing={selectedAd}
              setSelectedThing={setSelectedAd}
              thingsList={adListObject}
            />
          }
          {
            selectedComponent === 'tap' &&
            <Tab
              additionalClassName="mt-4 mb-4"
              selectedThing={selectedComponent}
              setSelectedThing={setSelectedComponent}
              thingsList={componentList}
            />
          }
          {
            selectedComponent === 'toast' &&
            <>
              <Toast
                state="warning"
                text="신청이 완료되었습니다"
                btnText="신청하기"/>
            </>
          }
          {
            selectedComponent === 'confirmModal' &&
            <>
              <BtnSm text="Confirm" color="blue" onClick={() => setConfirmModal(true)}/>
              <ConfirmModal
                show={confirmModal}
                sentence="삭제하시겠습니까?"
                cancelText="취소"
                confirmText="삭제"
                dismiss={() => setConfirmModal(false)}
              />
            </>

          }
          {
            selectedComponent === 'toggle' &&
            <Toggle/>
          }
          {
            selectedComponent === 'filter' &&
            <>
              <BtnSm text="필터" color="blue" onClick={() => setFilterModal(true)}/>
              <FilterModal
                show={filterModal}
                heading="광고저장"
                btnTextIcon="plus-box-outline"
                btnTextText="새 재생목록"
                btn100Text="완료"
                filterList={filterList}
                onClick={() => setFilterModal(false)}
              />
            </>
          }
        </>
      }

      {
        switchSection === 'set' &&
        <>
          <Tab
            additionalClassName="mt-4 mb-4"
            selectedThing={selectedSet}
            setSelectedThing={setSelectedSet}
            thingsList={setList}
          />
          {
            selectedSet === 'smallCardHorizontal' &&
            <SmallCardHorizontal
              source={setData}
            />
          }
          {
            selectedSet === 'smallCardVertical' &&
            <SmallCardVertical
              source={setData}
            />
          }
          {
            selectedSet === 'largeCardVertical' &&
            <LargeCardVertical
              source={setData}
            />
          }
        </>
      }
    </div>
  );
}

export default DesignSystem;
